import { useContext } from 'react';
import { AuthContext } from '../../providers/AuthProvider';
import { ApiMethod } from '../models/api-types.type';
import { routes } from '../../assets/constants';
import type { DevEnvSettings, DevEnvStatus } from '../models/dev-environment.model';

/** Sleep and wake the dev environment (super-admin, production API only). */
export const useDevEnvironmentApi = () => {
  const { sendAuthGuardedRequest } = useContext(AuthContext);
  return {
    status: () => sendAuthGuardedRequest(ApiMethod.GET, routes.adminDevEnv) as Promise<DevEnvStatus>,
    wake: () => sendAuthGuardedRequest(ApiMethod.POST, `${routes.adminDevEnv}/wake`, {}) as Promise<DevEnvStatus>,
    sleep: () => sendAuthGuardedRequest(ApiMethod.POST, `${routes.adminDevEnv}/sleep`, {}) as Promise<DevEnvStatus>,
    updateSettings: (patch: Partial<DevEnvSettings>) => sendAuthGuardedRequest(ApiMethod.PUT, `${routes.adminDevEnv}/settings`, patch) as Promise<DevEnvStatus>,
  };
};
